import { render, staticRenderFns } from "./WarehouseLocationSelect.vue?vue&type=template&id=36d54d6e"
import script from "./WarehouseLocationSelect.vue?vue&type=script&lang=ts"
export * from "./WarehouseLocationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports